<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a9vEqw/tc-custom/9781488058608.jpg?1740526264030" alt="This image is the cover for the book No Other Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Other Love
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i>–Bestselling Author: She and a masked bandit have an enemy in common—but dare she trust such a dangerous man?</b><br/><br/>Urgently on her way to the earl of Exmoor’s estate, Nicola Falcourt’s carriage is waylaid by a notorious highwayman known as The Gentleman. But there is nothing gentlemanly about the masked bandit’s breathless kiss.<br/><br/>The stranger believes Nicola is the wife of Richard Montford, earl of Exmoor, whom he despises and is intent on destroying. But he could not be more mistaken, for Nicola bears no love for the cruel earl who killed the only man she’d ever loved.<br/><br/>Determined to uncover the rogue’s real identity and his reasons for bringing down the earl, Nicola gets perilously close to him. But to save those she loves, she’ll have to put all her trust in a man as dangerous as he is desirable.<br/><br/>“A consummate storyteller.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Candace Camp
      </h2>
      
      <p class="authorDescription body article">Candace Camp is a New York Times bestselling author of over sixty novels of contemporary and historical romance. She grew up in Texas in a newspaper family, which explains her love of writing, but she earned a law degree and practiced law before making the decision to write full-time. She has received several writing awards, including the RT Book Reviews Lifetime Achievement Award for Western Romances. Visit her at www.candace-camp.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b2a0d148